import { formatISO } from "date-fns";

import getInternalLinkById from "../../utils/getInternalLinkById";
import getAuthorByCodename from "../author/getAuthorByCodename";

const getStructuredDataForArticle = (page) => {
  const author = getAuthorByCodename(
    page.elements.author_name.value.length > 0
    && page.elements.author_name.value[0].codename,
  );
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
  };

  if (author && author.elements.contact_item.value.length > 0) {
    const authorSD = [{
      "@type": "Person",
    }];

    if (author.elements.contact_item.value.length > 0) {
      authorSD[0].name = author.elements.contact_item.value[0].elements.name.value;
    }

    if (getInternalLinkById(author.id)) {
      authorSD[0].url = process.env.GATSBY_SITE_URL + getInternalLinkById(author.id).slug;
    }

    structuredData.author = authorSD;
  }

  if (page.system?.last_modified) {
    structuredData.dateModified = formatISO(new Date(page.system?.last_modified));
  }

  if (page.elements.publishdate?.value) {
    structuredData.datePublished = formatISO(page.elements.publishdate.value);
  }

  if (page.elements?.headline?.value) {
    structuredData.headline = page.elements?.headline?.value;
  }

  const imagesSD = [];

  if (page.elements?.hero_image?.value?.length > 0
      && page.elements?.hero_image?.value[0].elements?.image?.value?.length > 0
      && page.elements?.hero_image?.value[0].elements?.image?.value[0].url) {
    imagesSD.push(page.elements.hero_image.value[0].elements.image.value[0].url);
  } else if (page.elements?.image?.value?.length > 0
      && page.elements?.image?.value[0].elements?.image?.value?.length > 0
      && page.elements?.image?.value[0].elements?.image?.value[0].url) {
    imagesSD.push(page.elements.image.value[0].elements.image.value[0].url);
  }

  if (imagesSD.length > 0) {
    structuredData.image = imagesSD;
  }

  return structuredData;
};

export default getStructuredDataForArticle;
